import { webApiWithResponse } from "../../../../core/http/httpThunks";
import { CtrlGoodsData } from "../types";

export const createControlApi = (userId: string, ctrlgoods: CtrlGoodsData) =>
  webApiWithResponse<string>({
    method: "PUT",
    url: "clearing/newctrlgoods",
    params: {
      userId,
    },
    data: ctrlgoods,
  });

export default createControlApi;
